exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-f3db1e90] {\n  color: var(--v-anchor-base);\n}", ""]);

// exports
